import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search\">\n  <path d=\"M700.8 775.765333a384 384 0 1 1 74.965333-74.965333l147.370667 147.370667a53.034667 53.034667 0 0 1-74.965333 74.965333l-147.370667-147.370667zM469.333333 768a298.666667 298.666667 0 1 0 0-597.333333 298.666667 298.666667 0 0 0 0 597.333333z\" p-id=\"3245\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol